import Header from "../../../../components/header";
import { useNavigate } from 'react-router-dom';
import useAdminManageClerkHeader from '../hooks/use-admin-manage-clerk-header';
import ConfirmDialog from '../../../../components/dialogs/confirm-dialog';
import { AdminManageClerkInfoPane } from './admin-manage-clerk-info-pane';
import { Account } from '../../../../models/account';

export type AdminManageClerkHeaderProps = {
	clerk: Account;
}

export const AdminManageClerkHeader = (props: AdminManageClerkHeaderProps) => {
	const navigate = useNavigate();
	const {
		toggleDeleteModal,
		showDeleteModal,
		deleteClerk,
	} = useAdminManageClerkHeader();

	return (
		<>
			<Header>
				<div className="container flex flex-row items-center w-full mx-auto">
					<div className="container mx-auto text-3xl font-semibold text-white">
						View Clerk
					</div>
					<div className="container flex justify-end gap-2 px-6 py-2 mx-auto bg-transparent">
						<button
							className="flex items-center gap-2 px-4 py-2 font-semibold text-white uppercase bg-transparent border-2 rounded-md text-md"
							onClick={() => toggleDeleteModal()}>
							Delete
						</button>
						<button
							className="flex items-center gap-2 px-4 py-2 font-semibold uppercase bg-white rounded-md text-md text-primary-blue"
							onClick={() => navigate(`/clerks/edit/${props.clerk.id}`)}
						>
							Edit
						</button>
					</div>
				</div>
			</Header>
			<div className="flex flex-row justify-center pt-6 pb-6 m-12 bg-white rounded-lg -px-10">
				{props.clerk && props.clerk.id && <AdminManageClerkInfoPane clerk={props.clerk} />}
			</div>
			{showDeleteModal && (
				<ConfirmDialog
					isOpen={showDeleteModal}
					title="Delete Clerk"
					description="Are you sure you want to delete this clerk?"
					acceptText="Delete Clerk"
					rejectText="Cancel"
					toggle={() => toggleDeleteModal()}
					onSave={(value) => { value ? deleteClerk(props.clerk.id) : toggleDeleteModal() }}
					requireTextConfirmation={true}
					textConfirmationValue="delete"
				/>
			)}
		</>
	);
}
